export enum CreditMethodEnum {
  Cash = 1,
  LoyaltyCredit = 2
}
